export default {
  drafts: [],
  draft: null,
  adminOpen: false,
  fullScreen: false,
  teamOptions: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 18, 20, 22, 24],
  roundOptions: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
  durationOptions: [30, 45, 60, 90, 120, 150, 180],
  seenDraftBoardHelp: false,
  typeOptions: [
    { label: 'Snake', value: 'snake' },
    { label: 'Standard', value: 'standard' },
  ],
};
